export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';
export const DMY_DATE_FORMAT = 'DD/MM/YYYY';

export const DEFAULT_TIMEZONE = 'America/Chicago';

// same as moment.ISO_8601??
export const ISO_UTC_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';
export const ISO_UTC_FORMAT_DATE_FNS = "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'";
